import { render, staticRenderFns } from "./PartnerApplicationDetail.vue?vue&type=template&id=07c2a4ba&scoped=true"
import script from "./PartnerApplicationDetail.vue?vue&type=script&lang=js"
export * from "./PartnerApplicationDetail.vue?vue&type=script&lang=js"
import style0 from "./PartnerApplicationDetail.vue?vue&type=style&index=0&id=07c2a4ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c2a4ba",
  null
  
)

export default component.exports